import angular from 'angular';
import similarityComponent from './similarity.component';

let similarityModule = angular.module('similarity', [])

    .component('similarity', similarityComponent)

.name;

let states = [
   {
       name: 'similarity',
       url: '/similarity?infringement',
       component: 'similarity',
       resolve: {
           articles: (QueryAPI,$stateParams) => {
            "ngInject";
            if(!$stateParams.infringement) {
                 return null;
            } else {
               return $stateParams.infringement;
              }
           }
        }
   }
];

export default {name: similarityModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/similarity/similarity.js